import { fetchProductPicks, saveProductPicks } from "@/api/providerDashboard";

export default {
  async loadPicks() {
    this.picksLoading = true;
    this.picksError = false;
    try {
      const res = await fetchProductPicks();
      if (res.data.status !== 200) throw new Error("load");
      this.productPicks = res.data.data || [];
    } catch {
      this.picksError = true;
      this.$message.error("매장 PICK을 불러오지 못했습니다.");
    } finally {
      this.picksLoading = false;
    }
  },
  isPicked(product) {
    return this.productPicks.some((item) => item._id === product._id);
  },
  togglePick(product) {
    if (this.isPicked(product)) {
      this.productPicks = this.productPicks.filter((item) => item._id !== product._id);
    } else if (this.productPicks.length < 4) {
      this.productPicks.push(product);
    } else {
      this.$message.warning("매장 PICK은 최대 4개까지 선택할 수 있습니다.");
    }
  },
  movePick(index, direction) {
    const target = index + direction;
    if (target < 0 || target >= this.productPicks.length) return;
    const items = this.productPicks.slice();
    [items[index], items[target]] = [items[target], items[index]];
    this.productPicks = items;
  },
  async savePicks() {
    if (this.picksLoading || this.picksSaving || this.picksError) return;
    this.picksSaving = true;
    try {
      const res = await saveProductPicks(this.productPicks.map((item) => item._id));
      if (res.data.status !== 200) throw new Error("save");
      this.productPicks = res.data.data || [];
      this.$message.success("매장 PICK이 저장되었습니다.");
    } catch (error) {
      this.$message.error((error.response && error.response.data && error.response.data.message) || "매장 PICK 저장에 실패했습니다.");
    } finally {
      this.picksSaving = false;
    }
  },
};
